import * as yup from "yup";

export const CreatePasswordSchema = yup.object({
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Passwords must have at least 8 characters")
    .test("passwordRequirements", "Password must have at least one lowercase character", (value) =>
      [/[a-z]/].every((pattern) => pattern.test(value as string)),
    )
    .test("passwordRequirements", "Password must have at least one uppercase character", (value) =>
      [/[A-Z]/].every((pattern) => pattern.test(value as string)),
    )
    .test("passwordRequirements", "Password must have at least one number", (value) =>
      [/[0-9]/].every((pattern) => pattern.test(value as string)),
    )
    .test("passwordRequirements", "Password must have at least 1 special character", (value) =>
      [/[^a-zA-Z0-9]/].every((pattern) => pattern.test(value as string)),
    ),
  confirmPassword: yup
    .string()
    .required("Confirm password is required")
    .oneOf([yup.ref("password")], "Passwords do not match"),
  acceptedTerms: yup
    .boolean()
    .isTrue()
    .required(),
});

export const SendmeInstructionSchema = yup.object({
  acceptedTerms: yup
    .boolean()
    .isTrue()
    .required(),
});

export const CreateProfileSchemaV2 = yup.object({
  email: yup .string()
    .trim()
    .lowercase()
    .email("Email must be a valid email")
    .required("Email is required"),
  acceptedTerms: yup
    .boolean()
    .isTrue()
    .required(),
});

export const OTPVerifySchema = yup.object({
  otp: yup
    .string()
    .required("OTP is required")
    .matches(/^\d{6}$/, "OTP must be 6 digits"),
});


export const PersonalDetailsFormPartOneSchema = yup.object({
  firstName: yup
    .string()
    .trim()
    .required("First name is required")
    .max(48, "First name must be 48 characters max.")
    .matches(/^[a-zA-Z ]*$/, "First name is not valid"),
  lastName: yup
    .string()
    .trim()
    .required("Last name is required")
    .max(48, "Last name must be 48 characters max.")
    .matches(/^[a-zA-Z ]*$/, "Last name is not valid"),
});

export const CreateProfileSchema = yup.object({
  firstName: yup
    .string()
    .trim()
    .required("First name is required")
    .max(48, "First name must be 48 characters max.")
    .matches(/^[a-zA-Z ]*$/, "First name is not valid"),
  countryCode: yup
    .string()
    .default("+1"),
  lastName: yup
    .string()
    .trim()
    .required("Last name is required")
    .max(48, "Last name must be 48 characters max.")
    .matches(/^[a-zA-Z ]*$/, "Last name is not valid"),
  phone: yup
    .string()
    .nullable()
    .required("Mobile number is required")
    .min(12, "Mobile number is not valid format"),
  setphoneforlogin: yup
    .boolean()
    .default(false),
  email: yup
    .string()
    .trim()
    .lowercase()
    .email("Email must be a valid email")
    .required("Email is required"),

  channelFoundUs: yup.string().optional(),
  tellUsMore: yup.string().nullable(),
  location: yup.string().nullable(),
  contactId: yup.string().nullable(),
  primaryEmail: yup.string().nullable(),
  placeId: yup.string().nullable(),
  streetAddress: yup.string().required("Street Address is required"),
  address: yup.string().required("Address is required"),
  townCity: yup.string().required("Town/City is required"),
  zipCode: yup
    .string()
    .required("Zip code is required")
    .matches(/^\d{5}(-\d{4})?$/, "Invalid zip code"),
  country: yup.string().nullable(),
});

export type CreateProfileFormType = yup.InferType<typeof CreateProfileSchema>;
export type CreatePasswordFormType = yup.InferType<typeof CreatePasswordSchema>;
export type SendmeInstructionFormType = yup.InferType<typeof SendmeInstructionSchema>;
export type CreateProfileFormTypeV2 = yup.InferType<typeof CreateProfileSchemaV2>;
export type OTPVerifyFormType = yup.InferType<typeof OTPVerifySchema>;


